import { Card } from "@components/ui-kit";
import { t } from "@lingui/macro";
import { OutgoingInvoiceTypeEnum } from "@src/__generated__/urql-graphql";
import { useInvoiceDetailStore } from "@src/components/modules/invoices/Detail/store";
import { observer } from "mobx-react-lite";
import { CardTitle } from "../common";
import { ProjectsList } from "./ProjectsList";

export const ProjectsCard = observer(function ProjectsCard() {
  const store = useInvoiceDetailStore();

  return (
    <Card>
      <Card.Section>
        <CardTitle>
          {store.invoice?.type === OutgoingInvoiceTypeEnum.CreditNote
            ? t`Projects included on credit note`
            : t`Projects included on invoice`}
        </CardTitle>
        <ProjectsList />
      </Card.Section>
    </Card>
  );
});
